import { Suspense, lazy } from 'react';
import { Navigate, Outlet, useRoutes } from 'react-router-dom';
import { createBrowserRouter } from 'react-router-dom';
import { MainLayout } from '@/components/layout/main-layout';

const Home = lazy(() => import('@/pages'));
const BikeNiteroi = lazy(() => import('@/pages/bike-niteroi'));
const Transito = lazy(() => import('@/pages/transito'));
const Barcas = lazy(() => import('@/pages/barcas'));
const Chat = lazy(() => import('@/pages/chat/page'));
const Sobre = lazy(() => import('@/pages/Sobre'));
const Hero = lazy(() => import('@/components/Hero'));
const News = lazy(() => import('@/components/News'));
const WidgetMarketQuotes = lazy(() => import('@/components/WidgetMarketQuotes'));
const WidgetBikeNiteroi = lazy(() => import('@/components/WidgetBikeNiteroi'));
const Companies = lazy(() => import('@/components/Companies'));
const Newsletter = lazy(() => import('@/components/Newsletter'));
const Footer = lazy(() => import('@/components/Footer'));
const IAFloatButton = lazy(() => import('@/components/IAFloatButton'));
const IACivica = lazy(() => import('@/pages/ia-civica'));
const AgendaCultural = lazy(() => import('@/pages/agenda-cultural'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Suspense fallback={<div>Carregando...</div>}>
        <MainLayout>
          <Home />
        </MainLayout>
      </Suspense>
    ),
  },
  {
    path: '/bike-niteroi',
    element: (
      <Suspense fallback={<div>Carregando...</div>}>
        <BikeNiteroi />
      </Suspense>
    ),
  },
  {
    path: '/transito',
    element: (
      <Suspense fallback={<div>Carregando...</div>}>
        <Transito />
      </Suspense>
    ),
  },
  {
    path: '/barcas',
    element: (
      <Suspense fallback={<div>Carregando...</div>}>
        <Barcas />
      </Suspense>
    ),
  },
  {
    path: '/chat',
    element: (
      <Suspense fallback={<div>Carregando...</div>}>
        <Chat />
      </Suspense>
    ),
  },
  {
    path: '/sobre',
    element: (
      <Suspense fallback={<div>Carregando...</div>}>
        <MainLayout>
          <Sobre />
        </MainLayout>
      </Suspense>
    ),
  },
  {
    path: '/ia-civica',
    element: (
      <Suspense fallback={<div>Carregando...</div>}>
        <IACivica />
      </Suspense>
    ),
  },
  {
    path: '/agendaculturalniteroi',
    element: (
      <Suspense fallback={<div>Carregando...</div>}>
        <AgendaCultural />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: <Navigate to="/" replace />
  }
], {
  future: {
    v7_relativeSplatPath: true,
  }
});
